import entryLabelTemplate from '@/assets/labels/entry.label?raw'
import { LabelTemplateFields } from './types'

type EntryLabelTemplateOptions = {
  blankSecond?: boolean
}

function ensureDomSupport() {
  if (typeof DOMParser === 'undefined' || typeof XMLSerializer === 'undefined') {
    throw new Error('DYMO label rendering requires DOMParser/XMLSerializer support.')
  }
}

function setObjectText(
  document: XMLDocument,
  objectName: string,
  value: string | null | undefined
): void {
  const objects = Array.from(document.getElementsByTagName('TextObject'))
  const target = objects.find(node => {
    const nameNode = node.getElementsByTagName('Name').item(0)
    return nameNode?.textContent === objectName
  })

  if (!target) return

  const textNodes = target.getElementsByTagName('Text')
  for (let index = 0; index < textNodes.length; index += 1) {
    const textNode = textNodes.item(index)
    if (!textNode) continue
    textNode.textContent = value ?? ''
  }
}

export function renderEntryLabelTemplate(
  fields: LabelTemplateFields,
  options?: EntryLabelTemplateOptions
): string {
  ensureDomSupport()

  const parser = new DOMParser()
  const document = parser.parseFromString(entryLabelTemplate, 'application/xml')
  if (document.getElementsByTagName('parsererror').length > 0) {
    throw new Error('Unable to parse DYMO label template.')
  }
  const serializer = new XMLSerializer()

  const entryCode = fields.entryCode ?? ''
  const classCode = fields.classCode ?? ''
  const blankSecond = options?.blankSecond ?? false

  setObjectText(document, 'label1Class', classCode)
  setObjectText(document, 'lable1ID', entryCode)

  const secondClassValue = blankSecond ? '' : classCode
  const secondEntryCodeValue = blankSecond ? '' : entryCode

  setObjectText(document, 'label2Class', secondClassValue)
  setObjectText(document, 'lable2ID', secondEntryCodeValue)

  return serializer.serializeToString(document)
}
